import { useEffect, useState } from "react";
import Select from "../../../../components/Select";
import { UserService } from "../../../../services/UserService";

export default function Recommended({ searchObject, onChange, t }) {
  const pageNumber = 1;
  const pageSize = 1000;
  const [users, setUsers] = useState([]);
  const userSearch = { orderby: "nickname", order: 0 };
  useEffect(
    () =>
      UserService.getAllUsers(pageSize, pageNumber, userSearch).then((data) =>
        setUsers(data.users)
      ),
    []
  );
  return (
    <div>
      <legend className="fontsize-legend">{t("Recommended")}</legend>
      <Select
        className="form-select fontsize-legend"
        onChange={onChange}
        value={searchObject.recommended || ""}
        name="recommended"
      >
        <option value=""></option>
        {users.map((user) => (
          <option className="fontsize-legend" value={user.id}>
            {t(user.nickname)}
          </option>
        ))}
      </Select>
    </div>
  );
}
